import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';

const reqParams = '/engagement/churn';
const NightingaleChurnUsers = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
    </>
  );
};

export default NightingaleChurnUsers;